import '../main.css'
import '../../App.css'
import { useCallback, useEffect, useRef, useState } from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBarcode, faMap, faSortDown, faSortUp } from "@fortawesome/free-solid-svg-icons";
import MessageModal from '../messageModal';
import { ChevronLeft, Trash2, X, ShoppingBag, Tickets, MapPin, Info, ImageDown } from 'lucide-react';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import { changeNum, changeUnits, formatUTCDateTime } from '../common/function';
import { changeAlramModal, changeShoppingFlag, checkDuplicateLogins } from '../../store';
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from 'react-router-dom';
import { SyncLoader } from "react-spinners";
import Coupons_Header from './common/coupons_header';
import FallbackImage from '../common/FallbackImage';

function ShoppingHistory() {
    const { t } = useTranslation();

    const myData = useSelector((state) => state.myData);
    const mySkin = useSelector((state) => state.mySkin);
    const JWT = useSelector((state) => state.JWT.value);

    const [totalList, setTotalList] = useState([]);
    const [page, setPage] = useState(1);
    const [totalData, setTotalData] = useState(0)
    const [maxFirstCnt, setMaxFirstCnt] = useState(10)
    const [listSpinner, setListSpinner] = useState(true)

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    const preLocation = location?.state?.pre_location ?? ""

    useEffect(() => {
        if (page === 1) setListSpinner(true)
        ListData()
    }, [page]);

    const ListData = async () => {
        try {
            const params = new URLSearchParams();
            params.append("page", page.toString());
            params.append("take", maxFirstCnt);
            params.append("telegram_id", myData.id);

            const response = await axios.post(
                process.env.REACT_APP_API + '/api/exchange-events/coupon/user/purchase-history',
                params,
                {
                    headers: {
                        Authorization: `Bearer ${JWT}`,
                    },
                }
            );
            const tmp = response?.data ?? [];
            console.log(tmp);
            setTotalList((prev) => [...prev, ...tmp?.data ?? []]);
            setTotalData(tmp?.total ?? 0)
            setListSpinner(false)

        } catch (error) {
            if (error?.response?.status === 999) {
                dispatch(checkDuplicateLogins(true));
            } else {
                console.error(error);
            }
        }
    };

    const observerRef = useRef(null);

    useEffect(() => {
        if (totalList.length === 0) return;

        const observer = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting && totalData > page * maxFirstCnt) {
                // 바닥에 닿으면 페이지 증가
                setPage((prev) => prev + 1);
            }
        });

        if (observerRef.current) {
            observer.observe(observerRef.current);
        }

        return () => {
            if (observerRef.current) {
                observer.unobserve(observerRef.current);
            }
        };
    }, [totalList]);

    return (
        <div
            className="friend"
            style={{
                background: "#f5f5f5",
                padding: "0px",
                position: "relative",
                color: "#000"
            }}
        >
            <div style={{ padding: '0px', paddingBottom: '60px', fontFamily: 'sans-serif' }}>
                <Coupons_Header text={"shopping_26"} preLocation={preLocation} />

                <div style={{ padding: "15px", minHeight: "calc(100dvh - 250px)", marginTop: "50px" }}>
                    {
                        listSpinner
                            ?
                            <div style={{ marginTop: "100px" }}>
                                <SyncLoader
                                    color="#ffbb3f"
                                    size={10}
                                    cssOverride={{ borderWidth: "4px", marginBottom: "0px" }}
                                    speedMultiplier={1}
                                />
                            </div>
                            :
                            totalList?.length > 0
                                ?
                                <div style={{ paddingBottom: "0" }}>
                                    {totalList.map((item, idx) => (
                                        <div key={idx}>
                                            <div style={{ fontSize: "12px", fontWeight: "bold", marginBottom: "10px", textAlign: "left" }}>
                                                <span style={{ color: "#393939", paddingRight: "5px" }}>{t('shopping_30')}</span>
                                                <span>{formatUTCDateTime(item.bc_buy_time)}</span>
                                            </div>
                                            <div
                                                style={{
                                                    background: "#fff",
                                                    borderRadius: "8px",
                                                    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                                                    marginBottom: "30px",
                                                    textAlign: "left"
                                                }}
                                            >
                                                <div style={{ fontWeight: "bold", fontSize: "14px", padding: "12px 15px", borderBottom: "1px solid #f5f5f5" }}>
                                                    <span style={{ fontWeight: "bold" }}>to.</span> <span style={{ color: "gray", fontSize: "12px" }}>{item.owner_name}</span>
                                                </div>

                                                <div style={{ display: "flex", gap: "10px", padding: "12px 15px" }}>
                                                    <div
                                                        style={{
                                                            width: "75px",
                                                            height: "75px",
                                                            overflow: "hidden",
                                                            borderRadius: "4px",
                                                            border: "1px solid #f9f9f9"
                                                        }}
                                                    >
                                                        <FallbackImage
                                                            src={item?.bc_ci_custom_image_filename ? `${process.env.REACT_APP_IMGAPI}/images/coupons/${item.bc_ci_custom_image_filename}` : item.bc_ci_goods_img_big}
                                                            style={{
                                                                width: "100%",
                                                                height: "100%",
                                                                objectFit: "cover",
                                                            }}
                                                        />
                                                    </div>

                                                    <div style={{ width: "calc(100% - 75px)" }}>
                                                        <div style={{ fontSize: "11px", color: "#a9a9a9", fontWeight: "500" }}>
                                                            {item.bc_ci_brand_name}
                                                        </div>

                                                        <div className='table-overflow-2lines' style={{ fontSize: "12px", color: "#5f5f5f", fontWeight: "bold" }}>
                                                            {item.bc_ci_goods_name}
                                                        </div>

                                                        <div style={{ fontSize: "12px", marginBottom: "2px", fontWeight: "bold" }}>
                                                            {changeNum(item.eh_use_point)}p
                                                        </div>

                                                        <div style={{ fontSize: "11px", color: "#a9a9a9", fontWeight: "500" }}>
                                                            {t('shopping_22')}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                    <div ref={observerRef} style={{ height: '1px' }}></div>
                                </div>
                                :
                                <div style={{ width: "100%", margin: "30px 0" }}>
                                    <img src={`/img/noItem.png`} style={{ width: "150px", marginBottom: "10px" }} />
                                    <div style={{ width: "100%", textAlign: "center", fontSize: "18px", fontWeight: "bold", color: "#000", marginBottom: '5px' }}>{t('shopping_9')}</div>
                                </div>
                    }
                </div>
            </div>
        </div>
    );
}

export default ShoppingHistory;